import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { verificarCert } from "@/lib/api";

export default function Verificar() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [input, setInput] = useState(code || "");
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);

  const check = async (c) => {
    if (!c) return;
    setLoading(true); setRes(null);
    try {
      const r = await verificarCert(c.trim().toUpperCase());
      setRes(r);
    } catch {
      setRes({ valido: false });
    } finally { setLoading(false); }
  };

  useEffect(() => { if (code) check(code); /* eslint-disable-next-line */ }, [code]);

  return (
    <div className="lci" style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
      <div data-testid="verificar-card" style={{ width: "100%", maxWidth: 520, border: "1px solid var(--line)", borderRadius: 16, padding: 36, background: "var(--ink2)" }}>
        <div className="logo" style={{ justifyContent: "center", marginBottom: 8 }}>
          <div className="logo-mark">L</div>
          <div className="logo-txt">LIBERTI CLUB <em>IA</em>
          </div>
        </div>
        <h1 className="serif" style={{ fontSize: 26, fontWeight: 600, textAlign: "center", margin: "18px 0 6px" }}>Verificación de certificado</h1>
        <p style={{ color: "var(--muted)", fontSize: 14, textAlign: "center", fontWeight: 300, marginBottom: 24 }}>
          Introduce el código del certificado para comprobar su autenticidad.
        </p>
        <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
          <input data-testid="verificar-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder="LCI-XXXXXXXX"
            onKeyDown={(e) => e.key === "Enter" && check(input)}
            style={{ flex: 1, background: "var(--ink)", border: "1px solid var(--line)", color: "var(--cream)", padding: "12px 14px", borderRadius: 8, fontFamily: "monospace", letterSpacing: ".08em" }} />
          <button className="btn btn-gold btn-sm" data-testid="verificar-btn" onClick={() => check(input)} disabled={loading}>
            {loading ? "Verificando…" : "Verificar"}
          </button>
        </div>

        {res && res.valido && (
          <div data-testid="verificar-valido" style={{ border: "1px solid rgba(90,197,120,0.4)", borderRadius: 12, padding: 22, background: "rgba(90,197,120,0.06)" }}>
            <div style={{ color: "var(--ok, #5ac578)", fontWeight: 700, fontSize: 15, marginBottom: 12 }}>✓ Certificado válido y auténtico</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, fontSize: 14 }}>
              <div><span style={{ color: "var(--muted)" }}>Alumno/a: </span><b style={{ color: "var(--cream)" }}>{res.nombre}</b></div>
              <div><span style={{ color: "var(--muted)" }}>Programa: </span><b style={{ color: "var(--gold)" }}>{res.titulo}</b></div>
              <div><span style={{ color: "var(--muted)" }}>Fecha de emisión: </span><b style={{ color: "var(--cream)" }}>{res.fecha}</b></div>
              <div><span style={{ color: "var(--muted)" }}>Código: </span><b style={{ color: "var(--cream)", fontFamily: "monospace" }}>{res.codigo}</b></div>
            </div>
          </div>
        )}
        {res && !res.valido && (
          <div data-testid="verificar-invalido" style={{ border: "1px solid rgba(229,90,90,0.4)", borderRadius: 12, padding: 22, background: "rgba(229,90,90,0.06)", color: "#e57a7a", fontSize: 14 }}>
            ✕ No encontramos ningún certificado con ese código. Revisa que esté escrito correctamente.
          </div>
        )}

        <button className="link-gold" style={{ marginTop: 24, background: "none", border: 0, cursor: "pointer" }} onClick={() => navigate("/")}>← Volver a la web</button>
      </div>
    </div>
  );
}
